import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { UserState } from '@juvare/platform-sdk-react/types';
import { ConfigurationPageDef } from '@juvare/platform-sdk-react/ui/features/classifiers';

export function getConfigurationPagesByPermission(userState: UserState, pages: ConfigurationPageDef[]): ConfigurationPageDef[] {
    const hanPagesGroup = pages.filter((group) => group.groupLabel === 'Other');
    const allowedPages: ConfigurationPageDef[] = [];

    if (requireAnySystemPermission(userState, 'manage-all-classifiers')) {
        allowedPages.push(...pages);
    } else if (requireAnySystemPermission(userState, 'manage-client-classifiers')) {
        allowedPages.push(...hanPagesGroup);
    }

    return allowedPages;
}
